<template>
  <v-row>
    <v-col cols="12"></v-col>
      <div style="background-color:#FFFFFF; padding: 5px; font-size: 14px; margin-bottom:15px; color:#000000" class="rounded-lg">
        Deze offerte kan niet worden opgevraagd om één van de volgende redenen:<br /><br />
        <li>De offerte is reeds geaacepteerd of afgewezen.</li>
        <li>De link is verlopen</li>
        <li>De link is niet geldig</li>
        <br /><br />
        Mocht u nog vragen hebben neem dan gerust contact op met de <a href="https://blokhutwinkel.nl">blokhutwinkel.nl</a> (tel. 0575 200 200)
      </div>
  </v-row>
</template>

<script>
import { ref, watch, toRefs } from '@vue/composition-api'
import useLoader from '@/use/loader'

export default {
  components: {
  },
  setup(props, context) {
    return {
    }
  },
}
</script>

<style scoped>

.single-line {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}


.panel-header {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 3rem;
  letter-spacing: 0.0125em;
}
</style>